import React, { useState } from 'react'

import { Button, ListItem, ListItemText, MenuItem, Typography, Popover } from '@material-ui/core'

import { usePopupState, bindTrigger, bindMenu } from 'material-ui-popup-state/hooks'

import { makeStyles } from '@material-ui/core/styles'

import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
	selected: {
		'& .move-to': {
			marginLeft: 10,
			fontWeight: 800,
			fontSize: '14px',
			lineHeight: '19px',
			color: '#6B4AD6 !important',
			textTransform: 'uppercase',
			fontFamily: 'Nunito'
		},
		'& .selected-group': {
			fontFamily: 'Nunito',
			fontSize: '16px',
			lineHeight: '26px',
			marginLeft: 22,
			color: '#777679'
		}
	},
	menu: {
		cursor: 'pointer',
		border: '1px solid #6B4AD6',
		height: 40,
		width: 330,
		borderRadius: '100px'
	},
	listItem: {
		fontFamily: 'Nunito',
		fontSize: 16,
		color: '#3B0275',
		fontWeight: 'bold !important'
	},
	item: {
		padding: '13px 16px 13px 12px'
	},
	name: {
		fontFamily: 'Nunito',
		fontSize: '16px',
		fontWeight: 600,
		lineHeight: '22px',
		color: '#000000',
		margin: 0
	},
	capacity: {
		fontFamily: 'Nunito',
		fontSize: '16px',
		fontWeight: 600,
		lineHeight: '22px',
		color: '#777679',
		margin: 0
	},
	arrow: {
		color: '#6B4AD6 !important',
		marginTop: -6,
		'&:before': {
			fontSize: '18px'
		}
	},
	movePetButton: {
		fontFamily: 'Nunito',
		fontWeight: 800,
		fontSize: '14px',
		lineHeight: '19px',
		marginLeft: 8,
		paddingLeft: 32,
		paddingRight: 32
	}
}))

const SelectPet = (props) => {
	const classes = useStyles()

	let { playgroups, selectGroup, selected, group, visits } = props

	const [selectedGroup, setSelectedGroup] = useState(group || null)

	const popupState = usePopupState({
		variant: 'popover',
		popupId: 'playgroupMenu'
	})

	const renderTitle = () => (
		<div style={{ display: 'flex', alignItems: 'center' }}>
			<Typography className="move-to">MOVE TO</Typography>
			<Typography className="selected-group">{selectedGroup ? selectedGroup.name : 'Unassigned'}</Typography>
		</div>
	)

	const getCapacity = (group) => {
		let cap = group.capacity ? group.capacity : '?'
		let dogsInGroup = 0
		if (!visits || !visits.length) return ''
		visits.forEach((visit, i) => {
			if (visit.pet_status)
				visit.pet_status.forEach((pet, i) => {
					if (pet.playgroup == group._id) dogsInGroup += 1
				})
		})

		return `${dogsInGroup} / ${cap}`
	}

	return (
		<div
			style={{
				display: 'flex',
				marginLeft: 93
			}}>
			<ListItem className={clsx(classes.listItem, classes.menu)} {...bindTrigger(popupState)}>
				<ListItemText className={classes.selected} primary={renderTitle()} />
				<i className={clsx(['fas fa-sort-down', classes.arrow])} />
			</ListItem>
			<Popover
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'center'
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'center'
				}}
				{...bindMenu(popupState)}
				style={{ zIndex: 10001 }}
				PaperProps={{
					style: {
						width: 237
					}
				}}>
				<MenuItem
					className={classes.item}
					onClick={() => {
						popupState.close()
						setSelectedGroup(null)
					}}
					key={null}>
					<ListItemText className={classes.name} primary="Unassigned" />
				</MenuItem>
				{playgroups
					? playgroups.map((playgroup) => {
							let cap = getCapacity(playgroup)
							return (
								<MenuItem
									className={classes.item}
									onClick={() => {
										popupState.close()
										setSelectedGroup(playgroup)
									}}
									key={playgroup._id}>
									<ListItemText className={classes.name} primary={playgroup.name} />
									<ListItemText
										className={classes.capacity}
										style={{ flex: 'none' }}
										primary={cap}
									/>
								</MenuItem>
							)
					  })
					: null}
			</Popover>
			<Button
				disabled={
					(group && selectedGroup && group._id === selectedGroup._id) || !selected || !selected.length
				}
				variant="contained"
				color="primary"
				onClick={() => {
					selectGroup(selectedGroup)
					setSelectedGroup(null)
				}}
				className={classes.movePetButton}>
				Move Pets
			</Button>
		</div>
	)
}

export default SelectPet
